import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkhed() {

const cardData = {
keyword: "Corporate Cab Services in Khed MIDC",
headingDescription: "Citysky Cabs provides dependable corporate cab services in Khed MIDC for industrial employees, office teams, executives, factory staff, clients, vendors, and business visitors. Transportation can be arranged for daily office pickup and drop, employee commuting, factory shifts, corporate meetings, airport transfers, guest pickups, business travel, and outstation journeys. Corporate cab arrangements can connect Khed MIDC with Rajgurunagar, Chakan, Talegaon, Bhosari, Pimpri Chinchwad, Pune, Pune International Airport, and other important business and industrial destinations through planned driver-based transportation.",
topPlaces: [
{
title: "Khed MIDC",
description: "Khed MIDC is an important industrial destination with manufacturing, engineering, automotive, logistics, and supporting business activities. Corporate cabs can help employees, executives, factory staff, clients, and vendors travel conveniently between workplaces, residences, transport hubs, and business locations."
},
{
title: "Rajgurunagar",
description: "Rajgurunagar is a key commercial and residential center near Khed MIDC. Corporate transportation can connect employees and business travelers between Rajgurunagar and industrial workplaces for daily commuting, meetings, factory visits, client travel, and scheduled office requirements."
},
{
title: "Chakan MIDC",
description: "Chakan MIDC is a major industrial and automotive manufacturing hub in the Pune region. Cab services can support employee transportation, executive travel, vendor visits, client pickups, factory inspections, and business movement between Chakan and Khed MIDC."
},
{
title: "Chakan",
description: "Chakan is a prominent industrial and commercial destination with extensive manufacturing and logistics activity. Corporate cabs can provide transportation for staff, executives, suppliers, clients, and business visitors travelling between Chakan and Khed MIDC."
},
{
title: "Talegaon MIDC",
description: "Talegaon MIDC is a significant industrial area with manufacturing and corporate activity. Corporate transportation from Khed can support employee commuting, factory visits, business meetings, executive movement, and scheduled travel between the two industrial corridors."
},
{
title: "Bhosari MIDC",
description: "Bhosari MIDC is an established industrial area with engineering, manufacturing, automotive, and commercial businesses. Cab services can connect Khed MIDC employees and business travelers with Bhosari for meetings, industrial visits, office travel, and corporate requirements."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad is a major industrial and commercial region with numerous companies, offices, manufacturing units, and business facilities. Corporate cabs can support employee movement, client transfers, meetings, and business travel between Khed MIDC and Pimpri Chinchwad."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important travel point for corporate executives, employees, clients, and visiting professionals. Corporate airport cabs from Khed MIDC can be scheduled according to flight timings for airport pickup, drop, and guest transportation."
},
{
title: "Pune",
description: "Pune is a major technology, business, education, and commercial center connected with Khed MIDC through important road corridors. Corporate cabs can support employees, executives, clients, and business travelers travelling between Pune offices and industrial workplaces."
},
{
title: "Alandi",
description: "Alandi is a well-known town in the Pune region with residential, religious, and local commercial activity. Corporate transportation can connect Khed MIDC with Alandi for employee commuting, guest movement, business travel, and onward connections toward Pune and nearby areas."
}
],
services: [
{
name: "Corporate Cab Khed MIDC",
description: "Corporate Cab Khed MIDC provides organized transportation for employees, executives, clients, vendors, and business visitors. Cabs can be scheduled for daily office commuting, factory visits, meetings, airport transfers, guest movement, and corporate outstation travel."
},
{
name: "Corporate Taxi Khed MIDC",
description: "Corporate Taxi Khed MIDC supports companies requiring dependable transportation for professional travel. Services can cover employee movement, executive journeys, client pickups, business meetings, industrial visits, airport transfers, and scheduled intercity travel."
},
{
name: "Corporate Cab Booking Khed MIDC",
description: "Corporate Cab Booking Khed MIDC allows businesses to arrange transportation according to employee schedules, pickup locations, destinations, travel dates, and vehicle requirements. Advance planning can help coordinate office commuting, meetings, airport transfers, and guest transportation."
},
{
name: "Corporate Cab Rental Khed MIDC",
description: "Corporate Cab Rental Khed MIDC provides flexible vehicle arrangements for companies requiring transportation for meetings, factory visits, business events, employee travel, client movement, and longer corporate journeys. Rental requirements can be planned around duration and passenger needs."
},
{
name: "Employee Transportation Khed MIDC",
description: "Employee Transportation Khed MIDC helps industrial and commercial companies organize regular staff commuting between employee residences and workplaces. Routes can be coordinated according to shift timings, office schedules, pickup points, and workforce requirements."
},
{
name: "Office Pickup Drop Khed MIDC",
description: "Office Pickup Drop Khed MIDC provides scheduled transportation for employees travelling between their homes and offices. Companies can coordinate recurring pickup points and routes around working hours, staff locations, shift schedules, and office requirements."
},
{
name: "Corporate Employee Cab Khed",
description: "Corporate Employee Cab Khed is suitable for businesses requiring regular transportation for their workforce. Dedicated cab arrangements can support employee pickup and drop, shift-based travel, office commuting, and movement between residential areas and industrial workplaces."
},
{
name: "Industrial Employee Cab Khed",
description: "Industrial Employee Cab Khed supports factories, manufacturing units, warehouses, engineering companies, and industrial facilities requiring employee transportation. Routes can be organized around staff residential locations, reporting times, shift changes, and workplace schedules."
},
{
name: "Corporate Office Taxi Khed MIDC",
description: "Corporate Office Taxi Khed MIDC provides convenient transportation for office employees, executives, clients, and business visitors. Cabs can be scheduled for regular office travel, meetings, guest transfers, airport journeys, and professional appointments."
},
{
name: "Monthly Corporate Cab Khed",
description: "Monthly Corporate Cab Khed provides recurring transportation arrangements for companies with regular employee and business travel requirements. Monthly plans can support office commuting, factory shifts, executive movement, airport travel, and scheduled corporate journeys."
},
{
name: "Daily Office Cab Khed MIDC",
description: "Daily Office Cab Khed MIDC provides regular employee transportation between residences and workplaces. Daily routes can be coordinated according to office timings, employee pickup points, shift requirements, and the operational schedules of companies."
},
{
name: "Corporate Airport Cab Khed",
description: "Corporate Airport Cab Khed provides scheduled transportation between Khed MIDC and Pune International Airport for employees, executives, clients, and business guests. Pickup and drop services can be coordinated around flight schedules and corporate travel plans."
},
{
name: "Corporate Outstation Cab Khed MIDC",
description: "Corporate Outstation Cab Khed MIDC is suitable for business travel to Pune, Mumbai, Nashik, Ahmednagar, Aurangabad, Satara, Kolhapur, and other destinations. One-way and round-trip transportation can be arranged according to corporate itineraries."
},
{
name: "AC Corporate Cab Khed",
description: "AC Corporate Cab Khed provides comfortable air-conditioned transportation for employees, executives, clients, and business visitors. Vehicles can be arranged for office commuting, industrial visits, airport transfers, meetings, and longer corporate journeys."
},
{
name: "Affordable Corporate Cab Khed MIDC",
description: "Affordable Corporate Cab Khed MIDC provides practical transportation solutions for companies managing employee commuting, business travel, guest transfers, and regular office transportation. Vehicle requirements can be planned according to passenger numbers and travel schedules."
},
{
name: "Corporate Cab with Driver Khed",
description: "Corporate Cab with Driver Khed provides driver-based transportation for employees, executives, clients, and business guests. It can be arranged for office travel, factory visits, meetings, airport transfers, local business journeys, and outstation requirements."
},
{
name: "Company Employee Transport Khed",
description: "Company Employee Transport Khed helps organizations manage recurring employee movement between residential areas and workplaces. Transportation routes can be planned according to staff locations, shift timings, office schedules, and the specific commuting requirements of the company."
},
{
name: "Corporate Cab Service Near Me Khed",
description: "Corporate Cab Service Near Me Khed helps businesses and professionals find convenient corporate transportation around Khed MIDC and nearby industrial areas. Services can support employee commuting, client travel, airport transfers, meetings, and business visits."
},
{
name: "Business Travel Cab Khed MIDC",
description: "Business Travel Cab Khed MIDC supports professionals travelling for meetings, client appointments, factory inspections, conferences, vendor visits, and other work-related activities. Cabs can be scheduled for local business travel as well as longer intercity journeys."
},
{
name: "Corporate Guest Pickup Khed",
description: "Corporate Guest Pickup Khed provides transportation for clients, visiting executives, vendors, consultants, and other business guests. Pickup and drop arrangements can connect guests with offices, factories, hotels, airports, railway stations, and meeting locations."
},
{
name: "Factory Employee Transportation Khed MIDC",
description: "Factory Employee Transportation Khed MIDC helps manufacturing and industrial companies organize staff commuting around factory operations. Pickup and drop routes can be coordinated according to employee residences, shift schedules, reporting times, and workplace locations."
},
{
name: "Industrial Staff Cab Service Khed",
description: "Industrial Staff Cab Service Khed provides transportation for staff working in manufacturing plants, warehouses, engineering units, and other industrial facilities. Regular routes can be planned around staff requirements and the operating schedules of individual workplaces."
},
{
name: "Corporate Taxi Rental Khed MIDC",
description: "Corporate Taxi Rental Khed MIDC provides flexible transportation for business meetings, employee travel, executive movement, client transfers, airport journeys, factory visits, and corporate events. Rental arrangements can be planned according to duration and travel requirements."
},
{
name: "Employee Pickup Drop Service Khed",
description: "Employee Pickup Drop Service Khed provides organized transportation between staff residences and workplaces. Companies can coordinate recurring routes and pickup points based on employee locations, shift timings, office schedules, and daily commuting requirements."
},
{
name: "Corporate Car Rental Khed MIDC",
description: "Corporate Car Rental Khed MIDC provides vehicles for employees, executives, clients, guests, business meetings, airport transfers, industrial visits, and corporate events. Rental arrangements can be selected according to passenger capacity, journey duration, and travel requirements."
}
],
tableData: [
["Corporate Cab Khed MIDC"],
["Corporate Taxi Khed MIDC"],
["Corporate Cab Booking Khed MIDC"],
["Corporate Cab Rental Khed MIDC"],
["Employee Transportation Khed MIDC"],
["Office Pickup Drop Khed MIDC"],
["Corporate Employee Cab Khed"],
["Industrial Employee Cab Khed"],
["Corporate Office Taxi Khed MIDC"],
["Monthly Corporate Cab Khed"],
["Daily Office Cab Khed MIDC"],
["Corporate Airport Cab Khed"],
["Corporate Outstation Cab Khed MIDC"],
["AC Corporate Cab Khed"],
["Affordable Corporate Cab Khed MIDC"],
["Corporate Cab with Driver Khed"],
["Company Employee Transport Khed"],
["Corporate Cab Service Near Me Khed"],
["Business Travel Cab Khed MIDC"],
["Corporate Guest Pickup Khed"],
["Factory Employee Transportation Khed MIDC"],
["Industrial Staff Cab Service Khed"],
["Corporate Taxi Rental Khed MIDC"],
["Employee Pickup Drop Service Khed"],
["Corporate Car Rental Khed MIDC"]
],
whychoose: [
{
WhyChooseheading: "Industrial Employee Transportation",
WhyChoosedescription: "Khed MIDC serves a range of industrial and manufacturing businesses with regular staff commuting requirements. Corporate cab services can be organized around employee residences, factory locations, reporting times, and recurring shift schedules."
},
{
WhyChooseheading: "Scheduled Office Pickup and Drop",
WhyChoosedescription: "Companies can arrange recurring pickup and drop transportation for employees travelling to and from their offices. Routes can be coordinated around working hours, staff locations, shift timings, and workplace requirements."
},
{
WhyChooseheading: "Corporate Airport Transfers",
WhyChoosedescription: "Employees, executives, clients, and visiting professionals can use scheduled airport transportation from Khed MIDC to Pune International Airport. Pickup and drop journeys can be planned according to flight timings and business travel schedules."
},
{
WhyChooseheading: "Support for Factory Shifts",
WhyChoosedescription: "Industrial workplaces may operate across different shifts and reporting schedules. Cab transportation can be organized around factory timings to help companies coordinate regular employee movement between residential areas and industrial facilities."
},
{
WhyChooseheading: "Business and Executive Travel",
WhyChoosedescription: "Corporate transportation can support executives and professionals travelling for client meetings, factory inspections, vendor visits, conferences, and business appointments. Driver-based cabs can be arranged for both local and intercity travel."
},
{
WhyChooseheading: "Corporate Guest Transportation",
WhyChoosedescription: "Visiting clients, consultants, vendors, and executives can be provided with scheduled pickup and drop transportation. Corporate guest cabs can connect Khed MIDC offices and factories with airports, railway stations, hotels, and meeting venues."
},
{
WhyChooseheading: "Monthly Corporate Arrangements",
WhyChoosedescription: "Businesses with recurring transportation requirements can arrange longer-duration cab services for employee commuting, executive movement, airport travel, and regular business journeys. Routes and schedules can be planned around the company's operational needs."
},
{
WhyChooseheading: "Connectivity with Major Industrial Corridors",
WhyChoosedescription: "Khed MIDC is connected with important industrial and commercial areas including Chakan, Rajgurunagar, Talegaon, Bhosari, Pimpri Chinchwad, and Pune. Corporate cabs can support planned employee, executive, client, and business travel across these destinations."
}
]
};










const faqData = [
{
question: "How can companies arrange Corporate Cab Services in Khed MIDC with Citysky Cabs?",
answer: "Businesses operating in Khed MIDC can enquire about employee and corporate transportation by sharing office or factory locations, employee pickup points, shift timings, passenger count, and service frequency. Citysky Cabs can discuss a suitable cab arrangement for regular commuting, business travel, industrial visits, and other corporate requirements."
},
{
question: "Can Citysky Cabs provide employee pickup and drop services to Khed MIDC?",
answer: "Companies can discuss scheduled transportation for employees travelling to Khed MIDC from Pune and nearby residential areas. Pickup locations, workplace addresses, morning and evening shift timings, employee numbers, and preferred travel frequency can be provided to understand the daily transportation requirement."
},
{
question: "Can employees from Pune travel to Khed MIDC by corporate cab?",
answer: "Employees travelling from areas such as Chakan, Bhosari, Pimpri-Chinchwad, Wakad, Hinjewadi, Kharadi, and other parts of Pune can enquire about corporate cab transportation to Khed MIDC. The required pickup points, reporting time, passenger count, and workplace location can be shared for route planning."
},
{
question: "Can Corporate Cab Services in Khed MIDC support multiple employee shifts?",
answer: "Organizations operating different morning, evening, night, or rotating shifts can discuss transportation according to their employee schedules. Citysky Cabs can review the shift timings, pickup locations, workplace address, passenger count, and travel frequency when planning the corporate cab requirement."
},
{
question: "Can companies arrange corporate cabs for clients visiting Khed MIDC?",
answer: "Businesses can arrange transportation for clients, suppliers, consultants, vendors, executives, and other visitors travelling to Khed MIDC. Depending on the itinerary, transportation can be discussed for Pune pickup, hotel transfers, industrial visits, business meetings, and return journeys."
},
{
question: "Can Citysky Cabs provide airport transfers for employees travelling from Khed MIDC?",
answer: "Employees and corporate guests travelling through Pune Airport can enquire about transportation from Khed MIDC to the airport or from the airport to their workplace or hotel. Flight details, pickup address, passenger count, luggage requirements, and required reporting time can be shared while planning the airport transfer."
},
{
question: "Can corporate cabs be used for industrial visits and business meetings in Khed MIDC?",
answer: "Companies conducting factory visits, inspections, audits, supplier meetings, training programs, and other business activities can enquire about dedicated cab transportation. The pickup location, facility address, visitor count, meeting schedule, and return timing can be shared with Citysky Cabs."
},
{
question: "Can companies arrange outstation corporate travel from Khed MIDC?",
answer: "Professionals travelling from Khed MIDC to Mumbai, Pune, Nashik, Aurangabad, Kolhapur, Satara, Bangalore, Hyderabad, or other business destinations can enquire about outstation cab transportation. The destination, travel date, passenger count, and one-way or return requirement can be provided for planning."
},
{
question: "Can employees from different pickup locations share corporate cabs to Khed MIDC?",
answer: "Employees living in different areas can discuss shared transportation when their pickup routes and work timings are compatible. Providing the residential pickup points, total passenger count, Khed MIDC workplace address, and reporting time helps Citysky Cabs understand the group transportation requirement."
},
{
question: "What information is required for Corporate Cab Services in Khed MIDC?",
answer: "Companies can provide employee pickup locations, Khed MIDC office or factory address, passenger count, shift timings, travel dates, preferred vehicle category, and required service frequency. Information about multiple stops, airport transfers, client travel, and outstation business journeys can also be shared when applicable."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Vishal Shinde",
feedback:
"Our manufacturing unit in Khed MIDC has employees travelling from several nearby areas, with different reporting times during the week. We provided the pickup locations and shift details to Citysky Cabs, and the corporate cab arrangement gave our team a more organized way to manage the regular employee commute.",
rating: 5
},
{
id: 2,
name: "Miss. Priyanka Jadhav",
feedback:
"We had a supplier coming to our Khed MIDC facility for a scheduled business meeting and needed transportation from Pune. Citysky Cabs arranged the cab around the meeting and return timings we provided. It was convenient to have the visitor's complete travel plan handled around the same schedule.",
rating: 5
}
];









































































































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Khed MIDC",
  "image": "https://www.cityskycab.in/assets/images/corporate-cab-services-in-khed-midc.webp",
  "description": "Corporate Cab Services in Khed MIDC from Citysky Cabs are designed for companies, factories, industrial units and offices that require dependable employee transportation and organized business travel. The service includes Corporate Cab Khed MIDC, Corporate Taxi Khed MIDC, Corporate Cab Booking Khed MIDC and Corporate Cab Rental Khed MIDC for regular staff commuting, office travel and corporate transportation requirements. Employee Transportation Khed MIDC and Office Pickup Drop Khed MIDC can be arranged around employee residential locations, workplace schedules and shift timings. Corporate Employee Cab Khed and Industrial Employee Cab Khed are suitable for company staff and industrial workers, while Corporate Office Taxi Khed MIDC can support executives, employees and visiting business guests. Monthly Corporate Cab Khed and Daily Office Cab Khed MIDC provide flexible solutions for recurring travel, and Corporate Airport Cab Khed can be arranged for airport transfers and business visitors. Corporate Outstation Cab Khed MIDC is suitable for intercity meetings and longer business journeys, while AC Corporate Cab Khed, Affordable Corporate Cab Khed MIDC and Corporate Cab with Driver Khed offer comfortable transportation choices. Citysky Cabs can coordinate suitable vehicles, professional drivers, pickup points and routes according to corporate transportation requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/corporate-cab-services-in-khed-midc"
  }
};





    return (
        <div>


<Helmet>
  <title>
    Corporate Cab Services in Khed MIDC | Employee Transport & Industrial Office Taxi | +91 8554819191
  </title>

  <meta
    name="description"
    content="Corporate Cab Services in Khed MIDC by Citysky Cabs for employee transportation, office pickup and drop, industrial staff travel, daily corporate commuting, airport transfers and outstation business travel."
  />

  <meta
    name="keywords"
    content="Corporate Cab Services in Khed MIDC, Corporate Cab Khed MIDC, Corporate Taxi Khed MIDC, Corporate Cab Booking Khed MIDC, Corporate Cab Rental Khed MIDC, Employee Transportation Khed MIDC, Office Pickup Drop Khed MIDC, Corporate Employee Cab Khed, Industrial Employee Cab Khed, Corporate Office Taxi Khed MIDC, Monthly Corporate Cab Khed, Daily Office Cab Khed MIDC, Corporate Airport Cab Khed, Corporate Outstation Cab Khed MIDC, AC Corporate Cab Khed, Affordable Corporate Cab Khed MIDC, Corporate Cab with Driver Khed, Company Employee Transport Khed, Corporate Cab Service Near Me Khed, Business Travel Cab Khed, Corporate Guest Pickup Khed, Factory Employee Cab Khed MIDC, Khed MIDC corporate cab service, Khed MIDC employee transportation, Khed MIDC staff transport, Khed MIDC office cab service, Khed MIDC corporate taxi service, Khed MIDC company cab service, Khed MIDC industrial employee transportation, Khed MIDC employee pickup drop, Khed MIDC employee cab rental, Khed MIDC daily office cab, Khed MIDC monthly corporate cab, Khed MIDC shift transportation, Khed MIDC factory employee transport, Khed MIDC industrial cab service, Khed MIDC business taxi, Khed MIDC airport cab, Khed MIDC outstation taxi, Khed corporate travel service, Khed employee pickup and drop, Pune Khed corporate cab, Khed MIDC staff transportation"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/146.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabserviceinkhed;